import React from 'react';
import { motion } from 'framer-motion';
import { ButtonCTA } from './ButtonCTA';
export function Hero() {
  return <section className="relative overflow-hidden pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-55">
      {/* Decorative Blobs */}
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-brand-accent/40 blur-3xl" data-id="element-56" />
      <div className="absolute top-1/2 -left-24 h-64 w-64 -translate-y-1/2 rounded-full bg-brand-sage/20 blur-3xl" data-id="element-57" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-58">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-60">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-brand-text mb-6" data-id="element-61">
              Recupera tu Vitalidad y Dile Adiós a la Grasa Abdominal{' '}
              <span className="text-brand-terracotta italic" data-id="element-62">
                sin Dietas Extremas
              </span>
            </h1>
            <p className="text-lg sm:text-xl text-brand-text/80 mb-8 leading-relaxed" data-id="element-63">
              El Protocolo de Regulación Estrógeno-Cortisol diseñado
              específicamente para la mujer de 45+ que siente que su metabolismo
              se ha detenido.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-64">
              <ButtonCTA data-id="element-65">¡SÍ, QUIERO MI REINICIO AHORA!</ButtonCTA>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-66">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/veFYusEfhhe6b3XwdnFadg/reinicio_metabolico.png" alt="Reinicio Metabólico 45+ Ebook System" className="w-full h-auto object-cover" data-id="element-68" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}